import type { View } from 'react-native'
import { usePositioningLayout } from '~/hooks/layout'
import { useTooltipConstants } from '../constants'
import type { LayoutType } from '../types'

interface UseTooltipLayoutProps {
  isOpen: boolean
}

interface UseTooltipLayoutReturn {
  triggerLayout: LayoutType
  isLayoutReady: boolean
  rootRef: React.RefObject<View>
  handleLayout: (event: {
    nativeEvent: {
      layout: { x: number; y: number; width: number; height: number }
    }
  }) => void
  recalculateLayout: () => void
}

export function useTooltipLayout({
  isOpen,
}: UseTooltipLayoutProps): UseTooltipLayoutReturn {
  const tooltipConstants = useTooltipConstants()

  const {
    layout,
    isLayoutReady,
    elementRef,
    handleLayoutChange,
    recalculateLayout,
  } = usePositioningLayout({
    isActive: isOpen,
    config: {
      recalculationDelay: tooltipConstants.LAYOUT_RECALCULATION_DELAY,
      tolerance: tooltipConstants.LAYOUT_TOLERANCE,
    },
  })

  return {
    triggerLayout: layout,
    isLayoutReady,
    rootRef: elementRef,
    handleLayout: handleLayoutChange,
    recalculateLayout,
  }
}
